var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanyDropdownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#435EB2",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.456 13.544h14.456v28.912H14.456zM30.605 26.047h12.502v16.409H30.605zM30.605 22.4h12.502v1.953H30.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#435EB2",
    d: "M17.06 17.712h3.256v3.256H17.06zM17.06 22.791h3.256v3.256H17.06zM17.06 27.74h3.256v3.256H17.06zM22.791 27.74h3.256v3.256h-3.256zM22.791 17.712h3.256v3.256h-3.256zM22.791 22.791h3.256v3.256h-3.256zM34.251 35.163h5.47v7.293h-5.47z"
  }))));
}

export default __webpack_public_path__ + "./fonts/company-dropdown-icon.e31f4d6d8233e902a5878c95b8f9bc68.svg";
export { SvgCompanyDropdownIcon as ReactComponent };